import React, { FC } from "react";
import Modal, { ModalController } from "Components/Modal/Modal";
import { useTranslation } from "Providers/TranslationProvider";
import { DialogContent } from "@material-ui/core";
import ModalTitle from "Components/Modal/ModalTitle";
import { ExternalChatOrganization, ExternalChatUserState, } from "domain-entities";
import OrganizationsAddableView from "./OrganizationsAddableView";
import { SaveDocumentStore } from "Helpers/StoreHelper";

interface Props {
  modalController: ModalController<ExternalChatOrganization>;
  organizations: ExternalChatOrganization[];
  viewerUserStateStore: SaveDocumentStore<ExternalChatUserState>;
}

const OrganizationsAddableModal: FC<Props> = (props) => {
  const {t} = useTranslation();

  if (props.modalController.isOpen) {
    return (
      <Modal
        // pagePath={TrackingPage.AUTH_SIGN_OUT}
        modalController={props.modalController}
      >
        <ModalTitle
          close={props.modalController.close}
          title={t("OrganizationsAddableModal_Title")}
        />
        <DialogContent>
          <OrganizationsAddableView
            organizations={props.organizations}
            openWithOrganization={props.modalController.item}
            viewerUserStateStore={props.viewerUserStateStore}
          />
        </DialogContent>
      </Modal>
    );
  } else {
    return null;
  }
};

export default OrganizationsAddableModal;
